import type { Course, ProcessedCourse } from "@/common/course/types";
import { getAdvertisedCourseRun } from "@/lib/course/getAdvertisedCourseRun";
import { isNewProduct, type GoLiveDate } from "@/utils/isNewProduct";
import { parseNewWindowDays } from "@/utils/parseNewWindowDays";

const advertisedGoLiveDate = (course: ProcessedCourse): GoLiveDate =>
  getAdvertisedCourseRun(course as Course)?.goLiveDate ?? null;

export const isCourseNew = (
  course: ProcessedCourse,
  nowMs?: number,
  newWindowDays?: string | number | null,
): boolean =>
  isNewProduct(
    advertisedGoLiveDate(course),
    nowMs,
    parseNewWindowDays(newWindowDays),
  );

/**
 * Programs store no goLiveDate. Catalog cards use productCreated, which is
 * the program created date. A missing date fails closed.
 */
export const isProgramNew = (
  created: GoLiveDate,
  nowMs?: number,
  newWindowDays?: string | number | null,
): boolean => isNewProduct(created, nowMs, parseNewWindowDays(newWindowDays));
